import { Trophy } from 'lucide-react';
import { ContentRail } from './ContentRail';

export function CompetitionsSection({ competitions, navigate }) {
  if (!competitions.length) return null;

  return (
    <ContentRail
      icon={<Trophy className="w-5 h-5 text-emerald-500 shrink-0" />}
      title="Competitions on AfroSports"
      subtitle="Browse by league"
      seeAllPath="/competitions"
      navigate={navigate}
      testId="competitions-section"
    >
      {competitions.map((comp) => (
        <div
          key={comp.slug || comp.id}
          onClick={() => navigate(`/competitions/${comp.slug}`)}
          className="flex-shrink-0 w-[140px] sm:w-[160px] cursor-pointer group snap-start"
          data-testid={`competition-${comp.slug}`}
        >
          <div className="relative w-full aspect-square rounded-xl bg-[#141414] border border-white/[0.06] hover:border-emerald-500/30 flex flex-col items-center justify-center p-4 transition-all duration-300 group-hover:bg-[#1a1a1a]">
            <div className="w-14 h-14 mb-2.5 rounded-full overflow-hidden bg-black/30 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              {comp.logo_url ? (
                <img
                  src={comp.logo_url}
                  alt={comp.name}
                  loading="lazy"
                  className="w-11 h-11 object-contain"
                  onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.innerHTML = `<span class="text-xs font-bold text-gray-400">${(comp.short_name || comp.name || '').slice(0,4)}</span>`; }}
                />
              ) : (
                <Trophy className="w-6 h-6 text-gray-500" />
              )}
            </div>
            <h3 className="text-white font-semibold text-[11px] group-hover:text-emerald-400 transition-colors text-center leading-tight line-clamp-2">
              {comp.short_name || comp.name}
            </h3>
            {comp.live_matches > 0 && (
              <span className="mt-1.5 text-[8px] font-bold text-red-400 uppercase tracking-wider">{comp.live_matches} Live</span>
            )}
          </div>
        </div>
      ))}
    </ContentRail>
  );
}
